import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=18103f35&scoped=true&"
import script from "./Products.js?vue&type=script&lang=js&"
export * from "./Products.js?vue&type=script&lang=js&"
import style0 from "./Products.scss?vue&type=style&index=0&id=18103f35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18103f35",
  null
  
)

export default component.exports